import VehicleService from '@/services/requests/vehicleService'
import Store from '@/store/computed/storeHelpers'
export default {
  methods: {
    getVehicleTypes() {
      this.loadingVehicleTypes = true;
      VehicleService.getAllVehicleTypes().then(result => {
        //console.log(result);
        this.loadingVehicleTypes = false;
        this.vehicleTypes = result.data.result;
      }).catch(err => {
        console.log(err);
        this.loadingVehicleTypes = false;
        this.snackError();
      })
    }
  },
  computed: {
    loadingVehicleTypes: Store.getSet({ store: 'vehicleTypes', prop: 'loadingVehicleTypes' }),
    vehicleTypes: Store.getSet({ store: 'vehicleTypes', prop: 'vehicleTypes' })
  },
  mounted() {
    if (!this.vehicleTypes.length) {
      this.getVehicleTypes()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.vehicleTypes = [];
  },
}